/* Country Redirect Berni 2020 */
window.rbUtil = {};
/*const current_domain = "https://lapassione.cc";*/
const default_domain = "https://lapassione.cc";
const country_table = {
    "GB": "https://uk.lapassione.cc",
    "US": "https://us.lapassione.cc",
    "CA": "https://us.lapassione.cc",
    "AU": "https://au.lapassione.cc",
    "NZ": "https://au.lapassione.cc",
  	"FR": "https://fr.lapassione.cc",
  	"MC": "https://fr.lapassione.cc",
  	"DE": "https://de.lapassione.cc",
  	"AT": "https://de.lapassione.cc",
  	"ES": "https://es.lapassione.cc",
  	"IT": "https://it.lapassione.cc",
  	"VA": "https://it.lapassione.cc",
  	"SM": "https://it.lapassione.cc"
};
var check_loc = false;

/* remove after 15day from 12-02-2021 */
/*function forceExpirationLocalStorage(){
  if( Date.now() > 1613127687960){
    console.log("IN");
    if(window.localStorage.getItem('lp_stores_expire')){
     	window.localStorage.removeItem("lp_stores_expire");
      	window.localStorage.removeItem("lp_stores");
    } else {
     	window.localStorage.removeItem("lp_stores_expire");
      	window.localStorage.removeItem("lp_stores"); 
    }
  }
}
forceExpirationLocalStorage();*/

/* set cookie for shipping to value */
function setShippingCookie(shipping_country_code){
  var date = new Date();
  date.setTime(date.getTime() + (24 * 60 * 60 * 1000));
  var expires = "; expires=" + date.toGMTString();
  var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  if(isSafari){
    window.localStorage.setItem('sht', shipping_country_code);
  }
  document.cookie = "sht="+ shipping_country_code + expires + "; path=/";
  return true;
}

/* check if shipping to code is already in cookie */
function checkIfShipToCode(){
  	var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  	if(isSafari){
      window.rbUtil.safariSht = window.localStorage.getItem("sht");
    }
  	var offsetSht = document.cookie.indexOf("sht=");
    if(offsetSht == -1){
       return false;
    }
  	var cookieCode = document.cookie;
    var cookieCode = cookieCode.substring(offsetSht+4, offsetSht+6);
  	console.log(cookieCode);
  if(cookieCode){
   	return cookieCode; 
  } else {
   	return false; 
  }
}


/*check if shipTo param is passed with get */
function shippingToCurrent(){
  	
  	const queryString = window.location.search;
  	const urlParams = new URLSearchParams(queryString);
 	var shipToCode = urlParams.get('sht');
  if(shipToCode) {
   	 setShippingCookie(shipToCode);
    window.rbUtil.selected_ship_to = shipToCode;
  } else {
    shipToCode = checkIfShipToCode();
    if(shipToCode){   
      window.rbUtil.selected_ship_to = shipToCode;
      console.log("inCookie");
    } else {
      $.getJSON('https://freegeoip.live/json/', function (result) {
      	window.rbUtil.selected_ship_to = result.country_code;
        console.log(result.country_code);
        setShippingCookie(result.country_code);
      });
    }   
  }
}

shippingToCurrent();

// create cookie that last 2h
function createUCFCookie(hours) {
    if (hours) {
        var date = new Date();
        date.setTime(date.getTime() + (hours * 60 * 60 * 1000));
        var expires = "; expires=" + date.toGMTString();
        document.cookie = "usf=1" + expires + "; path=/";
        return true;
    }
    return false;
}

//Main script redirect
const get_current_params = window.location.href;
if (get_current_params.includes("usf=1")) {
    if (!createUCFCookie(1)) {
        check_loc = true; /* error on cookie creation anable redirect */
        /*console.log("Redirect error!"); */
    }

} else {
    if (!document.cookie.includes("usf=1")) {
        check_loc = true; /* no cookie found enable redirect */
        /*console.log("no cookie found!")*/
    }
}


if (check_loc) {
    $.getJSON('https://freegeoip.live/json/', function (result) {
      	window.rbUtil.selected_ship_to = result.country_code;
        var $country_code = result.country_code;
        var $country = result.country_name;

        /*if (country_table[$country_code]) {
            if (country_table[$country_code] === current_domain) {
                console.log("Stay");
                createUCFCookie(24);
            } else {
                window.location.replace(country_table[$country_code] + window.location.pathname + "?usf=1");
            }
        } else {
            if (default_domain === current_domain) {
                createUCFCookie(24);
                console.log("Stay");
            } else {
                window.location.replace(default_domain + window.location.pathname + "?usf=1");
            }
        }*/
      	var param_in = window.location.search;
        if (country_table[$country_code]) {
            if (country_table[$country_code] === current_domain) {
                console.log("Stay");
                createUCFCookie(24);
            } else {
              	if(param_in == "")
                	window.location.replace(country_table[$country_code] + window.location.pathname + "?usf=1");
              	else
                	window.location.replace(country_table[$country_code] + window.location.pathname + param_in + "&usf=1");
            }
        } else {
            if (default_domain === current_domain) {
                createUCFCookie(24);
                console.log("Stay");
            } else {
              	if(param_in == "")
              		window.location.replace(default_domain + window.location.pathname + "?usf=1");
              	else
                  	window.location.replace(default_domain + window.location.pathname + param_in + "&usf=1");
            }
        }
    });
}